export default "__VITE_ASSET__efea25fd__"